import React from "react";
import { Button, Tooltip } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { useAiAssistantAccess, useAuth } from "@/hooks/use-auth";
import { getCurrentAiPageContext, useCurrentAiPageContextStatus, pageContextNotice } from "./pageContext";
import { AI_CONTEXT_ACTION_EVENT, createChartAction } from "./contextActions.mjs";
import "./AiChartAction.css";

export default function AiChartAction({ chartId }) {
  const { companyId, facilityId } = useParams();
  // AI Assistant access: profile permission only (no `role === 1` bypass).
  const allowed = useAiAssistantAccess();
  const facilityAllowed = useAuth("facility_view");
  const { context, reason } = useCurrentAiPageContextStatus(companyId, facilityId);
  const chart = context?.charts?.find(item => item.chart_id === chartId);
  if (!allowed || !facilityAllowed || !chartId) return null;
  const launch = () => {
    const action = createChartAction(getCurrentAiPageContext(companyId, facilityId), chartId);
    if (action) window.dispatchEvent(new CustomEvent(AI_CONTEXT_ACTION_EVENT, { detail: action }));
  };
  return <div className="facility-ai-chart-action" data-ai-chart-id={chartId}>
    <Tooltip title={chart ? `Analyze ${chart.title} using its displayed data and filters` : pageContextNotice(reason) || "Chart data is unavailable"}>
      <span><Button size="small" type="text" icon={<MessageOutlined />} disabled={!chart} onClick={launch}
        aria-label={chart ? `Analyze ${chart.title}` : "Analyze chart"}>Analyze</Button></span>
    </Tooltip>
  </div>;
}
